import { SOLUTION_TYPE } from '../../../shared/constants/user-info/solutionType';
import { ValueOfKey } from '../../../utils-types';
import { EntityListFormValues } from '../../interfaces/entity-list/EntityListFilters';

export const LIST_MODE = {
  NUTRITION: 'NUTRITION',
  SCAN_IQ: 'SCAN_IQ',
} as const;

export type ListMode = ValueOfKey<typeof LIST_MODE>;

const nutritionFilterDefaultValues: EntityListFormValues = {
  businessEntityType: '',
  businessName: '',
  businessPhone: '',
  inbodyType: '',
  ownerName: '',
  paymentFlowType: '',
  status: '',
  scanIqStatus: '',
  solutions: [],
  solutionModeType: SOLUTION_TYPE.NUTRITION,
};

const scanIQFilterDefaultValues: EntityListFormValues = {
  businessEntityType: '',
  businessName: '',
  businessPhone: '',
  inbodyType: '',
  ownerName: '',
  paymentFlowType: '',
  status: '',
  scanIqStatus: '',
  solutions: [],
  solutionModeType: SOLUTION_TYPE.SCAN_IQ,
};

export const filterDefaultValues: Record<ListMode, EntityListFormValues> = {
  [LIST_MODE.NUTRITION]: nutritionFilterDefaultValues,
  [LIST_MODE.SCAN_IQ]: scanIQFilterDefaultValues,
};
